import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Lecture 285
import Home from './components/Home.vue';
import Portfolio from './components/portfolio/Portfolio.vue';
import Stocks from './components/stocks/Stocks.vue';

import Dashboard from './components/myrundash/dashboard/Dashboard.vue';
import RaceLog from './components/myrundash/RaceLog.vue';
import RacePlanner from './components/myrundash/RacePlanner.vue';
import TrainingPlan from './components/myrundash/TrainingPlan.vue';
import Login from './components/myrundash/LoginForm.vue';
import Registration from './components/Registration.vue';
import UserProfile from './components/UserProfile.vue';
import BuddyFinder from './components/myrundash/BuddyFinder'

import CoachDashboard from './components/myrundash/coach/Dashboard.vue';

import MarathondynamicsHome from './components/myrundash/marathondynamics/Home.vue';
import MarathondynamicsRegistration from './components/myrundash/marathondynamics/Registration.vue';
import JustkeeprunningHome from './components/myrundash/teamlandings/JustKeepRunning.vue';

import PasswordResetRequest from './components/password/PasswordResetRequest.vue';
import PasswordReset from './components/password/PasswordReset.vue';

import Map from './components/global/MapTest'

const routes = [
  // { path: '/stockhome', component: Home },
  { path: '/', component: Home },
  { path: '/portfolio', component: Portfolio },
  { path: '/stocks', component: Stocks },

  { path: '/profile', component: UserProfile },
  { path: '/dashboard', component: Dashboard },
  { path: '/racelog', component: RaceLog },
  { path: '/raceplanner', component: RacePlanner },
  { path: '/trainingplan', component: TrainingPlan },
  { path: '/buddyfinder', component: BuddyFinder, name: 'Buddy Finder' },

  { path: '/login', component: Login, name: 'Login' },
  { path: '/register', component: Registration },

  { path: '/coachdashboard', component: CoachDashboard },

  { path: '/marathondynamics', component: MarathondynamicsHome, name: 'MDI Home' },
  { path: '/marathondynamics/register', component: MarathondynamicsRegistration, name: 'MDI Registration' },
  { path: '/justkeeprunning', component: JustkeeprunningHome, name: 'JKR Home' },

  { path: '/reset-password', component: PasswordResetRequest, name: 'Password Reset Request' },
  { path: '/reset-password/:token', component: PasswordReset, name: 'Password Reset' },

  { path: '/map', component: Map },
]

export default new VueRouter({mode: 'history', routes})



// WEBPACK FOOTER //
// ./src/router.js